import { render, staticRenderFns } from "./SearchCooms.vue?vue&type=template&id=1d31dbcc&scoped=true"
import script from "./SearchCooms.vue?vue&type=script&lang=ts"
export * from "./SearchCooms.vue?vue&type=script&lang=ts"
import style0 from "./SearchCooms.vue?vue&type=style&index=0&id=1d31dbcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d31dbcc",
  null
  
)

export default component.exports